/**
 * 提供 html5 定位能力
 *
 * @file   geolocation.js
 * @author lizhaoming
 */

export default (() => {
  let lbsService = 'http://aladdin.wapmap.baidu.com/plugin';
  let rgcService = 'http://api.map.baidu.com/?qt=rgc&dis_poi=100&poi_num=10&ie=utf-8&oue=1&res=api';
  // let locationService = 'http://api.map.baidu.com/geocoding/v3/';
  // let addressService = 'http://api.map.baidu.com/reverse_geocoding/v3/';
  let defaults = {
    autoLoc: {
      expireTime: 0,
      onlyFromCookie: false,
      onlyFromHTML5: false,
      onlyFromNative: false,
      autoSaveToCookie: true,
      html5Timeout: 8000,
      nativeTimeout: 8000,
      onSuccess: null,
      onFail: null
    },
    search: {
      timeout: 8000,
      onSuccess: null,
      onFail: null
    }
  };
  let geoCookie;

  // 适配https, 由于首页里这个脚本并未用smarty渲染，所以地址写死
  if (location.protocol.indexOf('https') !== -1) {
    lbsService = 'https://sp2.baidu.com/90gHaDqh_cgXo1ufo-zN2TxrfQVwcu8e/plugin';
    rgcService = 'https://sp2.baidu.com/9_Q4sjOpB1gCo2Kml5_Y_D3/?qt=rgc&dis_poi=100&poi_num=10&ie=utf-8&oue=1&res=api';
    // locationService = 'https://api.map.baidu.com/geocoding/v3/';
    // addressService = 'https://api.map.baidu.com/reverse_geocoding/v3/';
  }

  function getHTML5Position(onSuccess, onFail, timeout) {
    if (!navigator.geolocation) {
      processCallback(onFail, {
        error: 2
      });
    }
    let timer = null;
    let onFailProcessed = false;
    navigator.geolocation.getCurrentPosition(function (result) {
      clearTimeout(timer);
      processCallback(onSuccess, result.coords);
    }, function (error) {
      if (onFailProcessed) {
        return;
      }
      onFailProcessed = true;
      clearTimeout(timer);
      if (error.code === error.PERMISSION_DENIED) {
        processCallback(onFail, {
          error: 4
        });
      } else {
        processCallback(onFail, {
          error: 2
        });
      }
    }, {
      timeout: timeout,
      maximumAge: 0,
      enableHighAccuracy: true
    });
    timer = setTimeout(function () {
      if (onFailProcessed) {
        return;
      }
      onFailProcessed = true;
      clearTimeout(timer);
      processCallback(onFail, {
        error: 2
      });
    }, timeout);
  }
  function parseCoords(coords, onSuccess, onFail, timeout) {
    // 这个接口有时候会返回空, 增加重试机制
    let retries = 0;
    let MAX_RETRY = 2;
    let callParser = function (coords, onSuccess, onFail, timeout) {
      getJSONP({
        url: lbsService,
        data: {
          ptype: 1,
          xyr: coords.longitude + '_' + coords.latitude + '_' + coords.accuracy,
          addr: 'city|district|street|city_code'
        },
        timeout: timeout,
        onSuccess(result) {
          if (result !== undefined) {
            let point = result.point;
            let addr = result.addr;
            if (point && addr && addr.city_code) {
              /* eslint-disable max-len */
              let position = new Position(point.x, point.y, coords.accuracy, addr.city_code, undefined, result.address, result.address, addr, coords.latitude, coords.longitude);
              return processCallback(onSuccess, position.output());

              /* eslint-disable max-len */
            }
          }

          if (retries < MAX_RETRY) {
            retries++;
            return callParser(coords, onSuccess, onFail, timeout);
          }

          /* eslint-disable no-else-return */else {
            return processCallback(onFail);
          }

          /* eslint-disable no-else-return */
        },

        onFail: onFail
      });
    };
    callParser(coords, onSuccess, onFail, timeout);
  }
  function rgcRequest(coords, onSuccess, onFail, timeout) {
    getJSONP({
      url: rgcService,
      data: {
        x: coords.longitude,
        y: coords.latitude
      },
      timeout: timeout,
      onSuccess(result) {
        let content = result && result.content;
        let addressDetail = content && content.address_detail;
        let cityCode = addressDetail && addressDetail.city_code;
        if (content && addressDetail && cityCode && cityCode !== 0) {
          let position = new Position(coords.longitude, coords.latitude, coords.accuracy, cityCode, undefined, content.address, content.address, {
            city: addressDetail.city,
            district: addressDetail.district,
            street: addressDetail.street,
            cityCode: cityCode
          });
          processCallback(onSuccess, position.output());
        } else {
          processCallback(onFail);
        }
      },
      onFail: onFail
    });
  }
  function processCallback(callback, data, state) {
    typeof callback === 'function' && callback(data, state);
  }

  /* eslint-disable max-params */
  function Position(x, y, accuracy, cityCode, timestamp, name, address, addr, lat, long) {
    this.x = parseFloat(x);
    this.y = parseFloat(y);
    this.accuracy = parseFloat(accuracy);
    this.cityCode = parseInt(cityCode, 10);
    this.timestamp = parseInt(timestamp, 10) || '';
    this.name = name || '';
    this.address = address || '';
    this.addr = addr || undefined;
    this.lat = lat || '';
    this.long = long || '';
  }
  Position.prototype.getCookieString = function () {
    return this.x + '_' + this.y + '_' + this.accuracy + '_' + this.cityCode + '_' + this.timestamp;
  };
  Position.prototype.output = function () {
    return {
      x: this.x,
      y: this.y,
      accuracy: this.accuracy,
      cityCode: this.cityCode,
      timestamp: this.timestamp,
      name: this.name,
      address: this.address,
      addr: this.addr || {},
      lat: this.lat,
      long: this.long
    };
  };
  Position.readFromCookie = function (cookie) {
    let info = cookie.split('_');
    return new Position(info[0], info[1], info[2], info[3], info[4]);
  };
  Position.readFromObject = function (object) {
    return new Position(object.x, object.y, object.accuracy, object.cityCode, object.timestamp, object.name, object.address, object.addr, object.lat, object.long);
  };
  geoCookie = {
    domain: '.baidu.com',
    path: '/',
    key: 'BAIDULOC',
    duration: 172800000,
    // 48h, 2 * 24 * 3600 * 1000

    get() {
      if (!navigator.cookieEnabled) {
        return false;
      }
      let match = document.cookie.match(new RegExp(this.key + '=([^;]+);?'));
      if (match) {
        return Position.readFromCookie(match[1]);
      }
      return false;
    },
    set(position) {
      if (!navigator.cookieEnabled) {
        return false;
      }
      position = Position.readFromObject(position);
      let expiration = new Date();
      expiration.setTime(expiration.getTime() + this.duration);
      position.timestamp = parseInt(Date.now(), 10);
      document.cookie = this.key + '=' + position.getCookieString() + ';domain=' + this.domain + ';path=' + this.path + ';expires=' + expiration.toGMTString();
      return position.output();
    },
    remove() {
      if (!navigator.cookieEnabled) {
        return false;
      }
      document.cookie = this.key + '=;domain=' + this.domain + ';path=' + this.path + ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
      return true;
    }
  };

  /* eslint-disable prefer-rest-params */
  /* eslint-disable guard-for-in */
  function extend(merged) {
    let sources = [].slice.call(arguments, 1);
    for (let i = 0; i < sources.length; i++) {
      for (let property in sources[i]) {
        merged[property] = sources[i][property];
      }
    }
    return merged;
  }
  /* eslint-disable prefer-rest-params */
  /* eslint-disable guard-for-in */

  let jsonpCallbackCounter = 0;
  function getJSONP(options) {
    let defaultOptions = {
      timeout: 8000,
      data: {},
      onSuccess: null,
      onFail: null
    };
    options = extend({}, defaultOptions, options);
    let callbackName = options.callback ? options.callback : 'geojsonp' + ++jsonpCallbackCounter;
    options.data.callback = callbackName;
    let timeout = false;
    let timer = setTimeout(function () {
      delete window[callbackName];
      timeout = true;
      processCallback(options.onFail);
    }, options.timeout);
    window[callbackName] = function (data) {
      clearTimeout(timer);
      if (timeout) {
        return;
      }
      processCallback(options.onSuccess, data);
      delete window[callbackName];
    };
    let src = options.url + (options.url.indexOf('?') + 1 ? '&' : '?');
    let paramPairs = [];
    for (let property in options.data) {
      paramPairs.push(property + '=' + encodeURIComponent(options.data[property]));
    }
    src += paramPairs.join('&');
    let script = document.createElement('script');

    // 部分浏览器请求moplus直接报错
    script.onerror = function () {
      clearTimeout(timer);
      processCallback(options.onFail);
    };
    script.type = 'text/javascript';
    script.src = src;
    document.getElementsByTagName('head')[0].appendChild(script);
  }
  return {
    getPosition(options) {
      options = extend({}, defaults.autoLoc, options);
      let expireTime = options.expireTime;
      if (expireTime > 0 || expireTime === 0 && options.onlyFromCookie === true) {
        let position = geoCookie.get();
        if (position && (parseInt(Date.now(), 10) - position.timestamp <= expireTime || expireTime === 0)) {
          processCallback(options.onSuccess, position.output(), {
            from: 'cookie'
          });
          return;
        }
      }
      if (options.onlyFromCookie === true) {
        processCallback(options.onFail, {
          error: 1
        });
        return;
      }
      let self = this;
      let isAndroid = /android/i.test(navigator.userAgent);
      if (options.onlyFromHTML5 || !options.onlyFromNative) {
        // get HTML5 location
        getHTML5Position(function (result) {
          // convert coordinates and get address details.
          parseCoords(result, function (position) {
            if (options.autoSaveToCookie === true) {
              position = self.savePosition(position);
            }
            processCallback(options.onSuccess, position, {
              from: 'html5'
            });
          }, function () {
            if (isAndroid && !options.onlyFromHTML5) {
              processCallback(options.onFail, {
                error: 3
              });
            } else {
              processCallback(options.onFail, {
                error: 3
              });
            }
          }, options.html5Timeout);
        }, function (e) {
          if (isAndroid && !options.onlyFromHTML5) {
            processCallback(options.onFail, {
              error: 3
            });
          } else {
            processCallback(options.onFail, e);
          }
        }, options.html5Timeout);
      } else {
        processCallback(options.onFail, {
          error: 3
        });
      }
    },
    searchAddress(address, cityCode, options) {
      options = extend({}, defaults.search, options, {
        addr: address || '',
        city_code: cityCode || 0
      });
      getJSONP({
        url: lbsService,
        data: {
          ptype: 2,
          addr: address || '',
          city_code: cityCode || 0
        },
        timeout: options.timeout,
        onSuccess(data) {
          let result = [];
          if (data && data.content) {
            let cityCode = data.current_city.code;
            let content = [].concat(data.content);
            for (let i = 0; i < content.length; i++) {
              let poi = content[i];
              let geo = poi.geo.split('|')[2].replace(';', '').split(',');
              let name;
              let address;
              if (poi.city_type != null) {
                name = address = poi.cname;
              } else {
                name = poi.name;
                address = poi.addr;
              }
              let position = new Position(geo[0], geo[1], 200, cityCode, undefined, name, address);
              result.push(position.output());
            }
          }
          processCallback(options.onSuccess, result);
        },
        onFail() {
          processCallback(options.onFail, {
            error: 1
          });
        }
      });
    },
    savePosition(position) {
      return geoCookie.set(position);
    },
    clearPosition() {
      return geoCookie.remove();
    },
    mercatorToAddress(options) {
      let defaults = {
        timeout: 8000,
        onSuccess: null,
        onFail: null
      };
      options = extend({}, defaults, options);
      rgcRequest({
        longitude: options.x,
        latitude: options.y,
        accuracy: options.accuracy
      }, function (position) {
        position.accuracy = position.accuracy || 200;
        processCallback(options.onSuccess, position);
      }, function () {
        processCallback(options.onFail, {
          error: 1
        });
      }, options.timeout);
    }
  };
})();